'use client'

import { useQuery } from '@tanstack/react-query'

import { GetHeaderElementViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export const useGetHeaderBanner = () => {
    return useQuery<GetHeaderElementViewModel>({
        queryKey: QueryKeys.Widgets.HeaderBanner,
        queryFn: () => fetchRequest({ endpoint: '/header-elements', method: 'GET', serviceName: 'cml' }),
        refetchOnMount: true,
        staleTime: 0,
    })
}
